import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e61a8ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"links\" data-v-1e61a8ff><a href=\"#\" data-v-1e61a8ff>Datenschutz</a><a href=\"#\" data-v-1e61a8ff>Impressum</a><a href=\"#\" data-v-1e61a8ff>Nutzungshinweise</a></div><div class=\"copy-right\" data-v-1e61a8ff>© 2022 WM Gruppe</div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}